var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ModalBase from "../components/modalbase.vue";
import { isProjectEntry, } from "./utilities/documentdialog";
import { clone, } from "./utilities/aux";
import { isArray, } from "./utilities/wsi4_typeguards";
let RequestDialog = class RequestDialog extends Vue {
    ok() { }
    cancel() { }
    get sortedParts() {
        return clone(this.parts, (arg) => isArray(arg, isProjectEntry))
            .sort((a, b) => a.articleName.localeCompare(b.articleName));
    }
};
__decorate([
    Prop({ required: true })
], RequestDialog.prototype, "parts", void 0);
__decorate([
    Inject()
], RequestDialog.prototype, "i18n", void 0);
__decorate([
    Emit()
], RequestDialog.prototype, "ok", null);
__decorate([
    Emit()
], RequestDialog.prototype, "cancel", null);
RequestDialog = __decorate([
    Component({
        components: {
            "modal-base": ModalBase,
        },
        name: "RequestDialog",
    })
], RequestDialog);
export default RequestDialog;
